import { Component } from "react";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

import Ok from "@material-ui/icons/Done";
import Bad from "@material-ui/icons/Error";
import PropTypes from "prop-types";

export default class ApiButton extends Component {
  render() {
    if (this.props.sending) {
      return <CircularProgress />;
    } else if (this.props.error) {
      return (
        <span>
          <Button
            color="primary"
            variant="outlined"
            onClick={this.props.onButtonClick}
          >
            {this.props.buttonLabel} <Bad color={"#ea0000"} />
          </Button>
          <br />
          <p style={{ color: "#ee1010" }}>
            {this.props.error.resource
              ? this.props.error.resource
              : this.props.error}
          </p>
        </span>
      );
    } else if (this.props.sent) {
      return (
        <Button
          color="primary"
          variant="outlined"
          onClick={this.props.onButtonClick}
        >
          {this.props.buttonLabel} <Ok color={"#40c457"} />
        </Button>
      );
    } else {
      return (
        <Button
          color="primary"
          variant="outlined"
          onClick={this.props.onButtonClick}
        >
          {this.props.buttonLabel}
        </Button>
      );
    }
  }

  static propTypes = {
    sending: PropTypes.bool,
    sent: PropTypes.bool,
    error: PropTypes.any,
    buttonLabel: PropTypes.string.isRequired,
    onButtonClick: PropTypes.func.isRequired,
  };
}
